(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["AsyncHelper"] = factory();
	else
		root["AsyncHelper"] = factory();
})(self, function() {
return /******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ client; }
});

;// ./client/util/watchdog.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*jshint esversion: 6 */
// implementing a watchdog timer as I'm worried about situations where `subscribe`
// call could never resolve/reject, deadlock. example situations:
// 1) job reporting its progress gets abruptly terminated
// 2) getCurrentState call doesn't resolve because job has yet to complete, but job
//    completes before watchContinuously is initialized
// not sure of the severity of these cases, but this is cheap to implement, so trying it
var Watchdog = /*#__PURE__*/function () {
  function Watchdog(callback, duration) {
    _classCallCheck(this, Watchdog);
    this.callback = callback;
    this.duration = duration;
    this.reset();
  }
  _createClass(Watchdog, [{
    key: "reset",
    value: function reset() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.callback, this.duration);
    }
  }, {
    key: "kick",
    value: function kick(fn) {
      var _this = this;
      return function () {
        _this.reset();
        return fn.apply(void 0, arguments);
      };
    }
  }]);
  return Watchdog;
}();

;// ./client/index.js
/*jshint esversion: 6 */



/**
 * ```
 * Frontend helper for async_helper
 *
 * // Usage
 * import AsyncHelper from 'async_helper';
 *
 * AsyncHelper.subscribe(jobId, progress => {
 *   console.log("PROGRESS!", progress)
 * }).then(endState => {
 *   console.log("Work DONE!", endState)
 *   // or failed, check jobState.failed
 * }).catch(error => {
 *   console.log("ERROR", error)
 * })
 * ```
 *
 * by default will timeout after DEFAULT_TIMEOUT, can be specified in call to `subscribe`
 */

var JOB_FAILED = 'failure';
var PROGRESS = 'progress';
var CHAN_ROOT = 'async_helper@';
var DEFAULT_TIMEOUT = 45 * 1000; // 45s

var isDone = function isDone(state) {
  return state.current >= state.target;
};
var isTerm = function isTerm(state) {
  return isDone(state) || state.failed;
};
// would be nice to always include jobId in all error messages ...
var err = function err(message) {
  return new Error("AsyncHelper: ".concat(message));
};
function getCurrentState(jobId) {
  return new Promise(function (resolve, reject) {
    var req = new XMLHttpRequest();
    req.open("GET", "/async_helper" + "?id=".concat(jobId));
    req.setRequestHeader('Accept', 'application/json');
    req.onload = function () {
      if (req.status == 200) {
        resolve(JSON.parse(req.response));
      } else {
        reject(err("net error: ".concat(req.status)));
      }
    };
    req.onerror = function () {
      reject(err("net error: ".concat(req.status)));
    };
    req.ontimeout = function () {
      reject(err("net timeout: ".concat(req.status)));
    };
    req.send();
  });
}

// perv!
function watchContinuously(jobId, callback) {
  return new Promise(function (resolve) {
    var channelId = "".concat(CHAN_ROOT).concat(jobId);
    var channel = window.pusher.subscribe(channelId);
    channel.bind(PROGRESS, function (progress) {
      var state = {
        current: progress[0],
        target: progress[1]
      };
      // are we there yet!?
      if (isDone(state)) {
        resolve();
      } else if (callback) {
        // no, still progressing
        callback(state);
      }
    });
    channel.bind(JOB_FAILED, resolve);
  });
}

// if job did not finish or fail, and we aren't receiving push updates anylonger,
// then assume we won't get anymore updates. try one last time query job state in case
// it is terminal, then raise a timeout error if not.
// note: this is pretty basic handling, you could get smarter than just checking isTerm,
// you could restart the whole subscribe method if you observe that progress did increase
function onTimeout(jobId, resolve, reject) {
  getCurrentState(jobId).then(function (jobState) {
    if (isTerm(jobState)) {
      resolve(jobState);
    } else {
      reject(err("timed out"));
    }
  }).catch(reject);
}
var AsyncHelper = {
  subscribe: function subscribe(jobId, callback) {
    var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_TIMEOUT;
    return new Promise(function (resolve, reject) {
      if (!jobId) {
        reject(err("missing job id"));
      }
      if (timeout) {
        // try to avoid deadlocks, see watchdog.js
        var watchdog = new Watchdog(function () {
          onTimeout(jobId, resolve, reject);
        }, timeout);
        callback = watchdog.kick(callback || function () {});
      }

      // handle case where job is terminated (completed or failed). In this case,
      // websocket would not yield
      getCurrentState(jobId).then(function (jobState) {
        // resolve now if job has terminated, else do nothing, let the websocket take over
        if (isTerm(jobState)) {
          resolve(jobState);
        }
      }, reject);

      // simultanously start listenning for push
      watchContinuously(jobId, callback).then(function () {
        getCurrentState(jobId).then(resolve, reject);
      }, reject);
    });
  },
  getState: getCurrentState,
  // in the future, when only using es6 modules, just export DEFAULT_TIMEOUT directly,
  // or drop usage of `add-module-exports` plugin
  DEFAULT_TIMEOUT: DEFAULT_TIMEOUT
};
/* harmony default export */ var client = (AsyncHelper);
__webpack_exports__ = __webpack_exports__["default"];
/******/ 	return __webpack_exports__;
/******/ })()
;
});